import './accessconfig.scss';

const elements = document.querySelectorAll('[data-init="accessConfig"]');

// Add functionality to select all radio buttons in a column
elements.forEach(element => {
	const selectAlls = element.querySelectorAll('[data-accessConfig]');

	// Select corresponding radio buttons
	selectAlls.forEach(selectAll => {
		selectAll.addEventListener('change', event => {
			event.preventDefault();

			const targetValue = selectAll.dataset.accessconfig;
			const targets = element.querySelectorAll(`[value="${targetValue}"]`);

			targets.forEach(target => {
				target.checked = true;
			});
		});
	});

	// Reset when selecting single radio button
	element.addEventListener('change', event => {
		if (!event.target.matches('[data-accessConfig]')) {
			selectAlls.forEach(selectAll => {
				selectAll.checked = false;
			});
		}
	});
});
